import { Component, OnInit, Output, EventEmitter, Input, ViewChild, ElementRef, AfterViewInit } from '@angular/core';

@Component({
    selector: 'app-info-modal',
    templateUrl: './info-modal.component.html',
    styles: [],
    standalone: false
})
export class InfoModalComponent implements OnInit, AfterViewInit {
  @Input() head?;
  @Input() hasCancelBtn? = false;
  @Input() description = 'default_modal_description';
  @Input() confirmText = 'Generic.ok_button';
  @Input() type?: 'success' | 'warning' | 'info';
  @Output() hide = new EventEmitter<void>();
  @Output() callback? = new EventEmitter<void>();
  @ViewChild('modalTitle') modalTitle: ElementRef;
  @ViewChild('primaryActionButton') primaryActionButton: ElementRef;


  constructor() {}

  ngOnInit(): void {}

  ngAfterViewInit(): void {
    setTimeout(() => {
      if (this.primaryActionButton) {
        this.primaryActionButton.nativeElement.focus();
      } else if (this.modalTitle) {
        this.modalTitle.nativeElement.focus();
      }
    }, 100);
  }

  get icon() {
    switch (this.type) {
      case 'success':
        return 'ico-check-filled';
      case 'warning':
        return 'ico-info-circled';
      case 'info':
        return 'ico-info-circled';
      default:
        return '';
    }
  }

  emitCallback() {
    this.callback.emit();
    this.hide.emit();
  }
}
